import { useEffect } from "react";
import { Link } from "react-router-dom";

interface MenuItem {
  label: string;
  to: string;
}

const publicItems: MenuItem[] = [
  { label: "About", to: "/about" },
  { label: "The Spirit of JivaSeva", to: "/spirit" },
  { label: "JivaSeva Services", to: "/app" },
  { label: "Core Committee", to: "/app/core-committee" },
  { label: "Download App", to: "/download-app" },
  { label: "Raise a Concern", to: "/raise-a-concern" },
  { label: "Contact Us", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" }
];

interface Props {
  open: boolean;
  onClose: () => void;
}

export function MenuDrawer({ open, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        className={`drawer-overlay${open ? " is-open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className={`drawer${open ? " is-open" : ""}`}
        aria-hidden={!open}
        aria-label="Site menu"
      >
        <div className="drawer-header">
          <h2 className="drawer-title">JivaSeva</h2>
          <button
            type="button"
            className="drawer-close"
            aria-label="Close menu"
            onClick={onClose}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <nav className="drawer-nav">
          <div className="drawer-section">
            <ul>
              {publicItems.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} onClick={onClose}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </aside>
    </>
  );
}
